module.exports = __webpack_public_path__ + "img/telefono-blanco.f8f9664c.svg";